import type { IconColor, IconType } from "@anna-money/anna-web-ui";
import { Icon } from "@anna-money/anna-web-ui";
import type { ComponentProps, FC } from "react";

type IconSize = NonNullable<ComponentProps<typeof Icon>["size"]>;

type Pp2IconProps = {
  type: IconType;
  /** "m" = 20px, the size of the quick-contact and address icons */
  size?: IconSize;
  color?: IconColor;
  className?: string;
};

/**
 * Decorative library icon. The library `Icon` has no aria-hidden prop and renders an SVG plus
 * a non-breaking space, so it is wrapped in an aria-hidden span (spec 2.4).
 */
export const Pp2Icon: FC<Pp2IconProps> = ({ type, size = "m", color = "themeGreen", className }) => (
  <span aria-hidden="true" className={className}>
    <Icon type={type} size={size} color={color} />
  </span>
);
